import { render } from "./TheG01Content.vue?vue&type=template&id=0bbf6242&scoped=true&ts=true"
import script from "./TheG01Content.vue?vue&type=script&lang=ts"
export * from "./TheG01Content.vue?vue&type=script&lang=ts"

import "./TheG01Content.vue?vue&type=style&index=0&id=0bbf6242&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bbf6242"]])

export default __exports__